import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { Button } from '~/shared/components/Button/Button';
import { SortingSelectionProps } from '../models/M170ProductFilter';

const StyledOptionButton = styled(Button)<{ selected: boolean }>(
	({ theme }) => ({
		fontSize: theme.fontSizes.xs,
		fontWeight: theme.fontWeights.light,
		textTransform: 'none',
	}),
	ifProp('selected', ({ theme }) => ({
		fontWeight: theme.fontWeights.medium,
	})),
);

const StyledWrapper = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-end',
	gap: theme.space[4],
}));

export const SortingSelection = (props: SortingSelectionProps) => {
	const {
		sorting: { options },
		onSelected,
	} = props;
	const selectedSortingId = options.find(({ selected }) => selected)?.id;
	return (
		<StyledWrapper className={props.className}>
			{options.map((option) => (
				<StyledOptionButton
					key={option.id}
					variant="plain"
					selected={option.id === selectedSortingId}
					type="button"
					onClick={() => onSelected(option.id)}
				>
					{option.label}
				</StyledOptionButton>
			))}
		</StyledWrapper>
	);
};
